import React from 'react';

import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Desktop/components/AllParamsButton';
import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';

import MileageFilter from './components/MileageFilter';
import PriceFilter from './components/PriceFilter';
import GearboxFilter from './components/GearboxFilter';
import WheelFilter from './components/WheelFilter';
import EngineTypeFilter from './components/EngineTypeFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import BatteryCapacityFilter from './components/BatteryCapacityFilter';
import SpecialFilter from './components/SpecialFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import ClearanceFilter from './components/ClearanceFilter';
import SeatsFilter from './components/SeatsFilter';
import DoorsFilter from './components/DoorsFilter';
import ElectricEnginesFilter from './components/ElectricEnginesFilter';
import EnginePowerFilter from './components/EnginePowerFilter';

export function ParamsFilterCommercial() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <MileageFilter />
        <PriceFilter />
        <GearboxFilter />
      </FiltersWrapper>

      <AllParamsButton />

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <WheelFilter />
          <EngineTypeFilter />
          <EngineCapacityFilter />
          <EnginePowerFilter />
          <ClearanceFilter />
          <SeatsFilter />
          <DoorsFilter />
          <BatteryCapacityFilter />
          <PowerReserveFilter />
          <ElectricEnginesFilter />
        </FiltersWrapper>
      </MoreParams>

      <SpecialFilter />
    </React.Fragment>
  );
}
